export class RegistrationRequest{
    public ID: number;
    public HashCode: string;
    public Board: string;
    public Medium: string;
    public InstituteTypeID: string;
    public UDiseNo: string;
    public SSCIndexNo: string="";
    public HSCIndexNO: string="";
    public Office: number;
    public TypeOfTrust: number;
    public AcquiredDate: Date;
    public Section: string;
    public Standard: string;
    public Area: string;
    public State: number;
    public City: number;
    public Trust: string;
    public TrustAddress:string;
    public TrustMobileNo: string;
    public TrustMailID: string;
    public SchoolName: string;
    public SchoolAddress: string;
    public SchoolMobileno: string;
    public SchoolMailID: string;
    public SchoolLocation: number;
    public InfrastructureID: number;
    public NoOfInfrastructure: number;
    public InfrastructureSize: number;
    public OtherInfrastructure:string;
    public InfrastructureDetail: Array<any> = [];
    public EmployeeTypeID: number;
    public NoOfPermanentEmployee: number;
    public NoOfAdhocEmployee: number;
    public TotalPermanentSalary: number;
    public TotalAdhocSalary: number;
    public EmployeeDetail: Array<any> = [];
    public SchoolType: number;
    public RegistrationDate: string;
    public TrusteeName: string = "";
    public TrusteeAddress: string= "";
    public TrusteeMobileNo: string= "";
    public TrusteeMailID: string= "";
    public TrusteeDetail: Array<any> = [];
    public DocumentDetail: Array<any> = [];
    public Remarks: string ="";
    public RequestStatus: number;
    public AffiliationNumber: string;
    public AffiliationNumberAcquireDate : Date;
    public Pincode:string;
}